import React, {useEffect, useState} from 'react';

import {useHttpClient} from '../../../../common/hook/http';
import {useFrom} from '../../../../common/hook/form';
import {useToast} from '../../../../common/hook/toast';

import {validatorLength} from '../../../../common/util/validators';

import showValidators from '../../../../common/util/show-validators';

import FormElement from '../../../../common/component/FormElement/FormElement';

import NoContent from '../../../../common/component/NoContent/NoContent';
import Loader from '../../../../common/component/Loader/Loader';
import cardNumber from '../../../../common/util/card-number';

import * as IconFi from 'react-icons/fi';

import {Row, Col, Form, Button, Spinner, Table} from 'react-bootstrap';

import './CustomerClubCardNumber.scss'

const CustomerClubCardNumber = () => {
    const {callAPI} = useHttpClient();
    const {callToast} = useToast()

    // ------------------------------------------------------------------------------------------------------ fetch data
    const [data, setData] = useState(null)

    const fetchData = async () => {

        try {
            const responseData = await callAPI(
                `user/cardNumbers`
            );

            if (responseData.message) {
                callToast('secondary', null, null, responseData.message);
            } else {

                setData(responseData.result)

            }

        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {

        fetchData()

    }, [])

    // ----------------------------------------------------------------------------------------------------- submit form

    const [spinnerShow, setSpinnerShow] = useState(false)

    const [formState, inputHandler] = useFrom({
        formCustomerClubCardNumberNumber: {
            value: '',
            isValid: false
        }
    }, false);

    const formSubmitHandler = async event => {

        event.preventDefault();

        if (formState.isValid) {

            setSpinnerShow(true);

            try {
                const responseData = await callAPI(
                    'user/saveCardNumber',
                    'POST',
                    JSON.stringify({cardNumber: formState.inputs.formCustomerClubCardNumberNumber.value.replaceAll('-', '')})
                )

                if (responseData.message)
                    callToast('secondary', null, null, responseData.message);
                else {

                    callToast('secondary', null, null, 'ثبت شماره کارت با موفقیت انجام شد');

                    setData(responseData.result)

                }

                setSpinnerShow(false);

            } catch (err) {
                setSpinnerShow(false);
            }

        } else showValidators(formState.inputs)

    }

    // -----------------------------------------------------------------------------------------------------------------

    const removeHandler = async (e, item) => {

        e.target.closest('.btn').querySelector('i').classList.add('opacity-100')

        try {
            const responseData = await callAPI(
                'user/deleteCardNumber',
                'POST',
                JSON.stringify({id: item.id})
            )

            if (responseData.message)
                callToast('secondary', null, null, responseData.message);
            else {

                setData(responseData.result)

                callToast('secondary', null, null, 'حذف شماره کارت با موفقیت انجام شد');

            }

            setSpinnerShow(false);

        } catch (err) {
            setSpinnerShow(false);
        }

    }

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <div id="pageAccountCustomerClubCardNumber">
            <Row>
                <Col xs={12}>
                    <Form id="formCustomerClubCardNumber" onSubmit={formSubmitHandler} autoComplete="off">
                        <Row className="gx-3">
                            <Col md={12}>
                                <FormElement component="INPUT" type="text" id="formCustomerClubCardNumberNumber"
                                             name="cardNumber"
                                             label="شماره کارت"
                                             validators={[validatorLength([19, 19])]}
                                             maxLength="19"
                                             textInvalid="شاره کارت را وارد نمایید"
                                             placeholder="0000-0000-0000-0000"
                                             onInput={inputHandler}
                                             className="ltr text-left font-en ls-half"
                                             // مقدار key جهت رندر اجباری ست شد تا فیلد خالی شود
                                             digit cardNumber key={data?.length ? data[0].id : 1}/>
                            </Col>
                            <Col xs={12} className="py-2 py-md-0 mt-md-0 d-grid d-md-block bg-body page-footer">
                                <Button type="submit" className="m-1 m-md-0 btn-loading" disabled={spinnerShow || !data}>
                                    <Spinner as="i" animation="border" size="sm" className={spinnerShow && 'opacity-100'}/>
                                    <span>ثبت شماره</span>
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                    {
                        data ? (
                            data.length ? (
                                <Table responsive className="mb-0 bg-elevate-2 mt-md-3">
                                    <tbody>
                                    {
                                        data.map(item => {
                                            return (
                                                <tr key={item.id}>
                                                    <td className="font-en ls-half align-middle">{cardNumber(item.cardNumber)}</td>
                                                    <td className="text-nowrap text-end">
                                                        <Button variant="link" className="btn-icon btn-loading" onClick={e => removeHandler(e, item)}>
                                                            <Spinner as="i" animation="border" size="sm"/>
                                                            <IconFi.FiTrash size={24} className="sw-1"/>
                                                        </Button>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                    </tbody>
                                </Table>
                            ) : (
                                <div className="py-5 my-5">
                                    <NoContent text={`شماره کارتی ثبت نشده است`}/>
                                </div>
                            )
                        ) : (
                            <div className="py-5 my-5">
                                <Loader text="در حال دریافت اطلاعات"/>
                            </div>
                        )
                    }
                </Col>
            </Row>
        </div>
    )
}

export default CustomerClubCardNumber;